export default {
  MuiTabs: {
    indicator: {
      backgroundColor: 'transparent',
    },
  },
};
